import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import DocumentTemplateUtils from 'services/DocumentTemplateUtils';
import patientSignaturePlaceholderUrl from 'assets/img/placeholder_patient_signature.png';
import staffSignaturePlaceholderUrl from 'assets/img/placeholder_signature.png';
import { useNavStack } from 'careand-redux/slices/ui/hooks';
import { Stacks } from 'careand-redux/slices/ui/navigation';
import { PatientSignatureCanvasResultListener } from 'scenes/PatientTemplate/PatientSignatureCanvas';
import RouteUtils from 'services/RouteUtils';
import { isEditableBy } from '../SelectedElementEditPanel/EditableByRolesEnum';
import { UserRoleEnum } from 'generated/api';

const DocumentTemplateSignature = (props) => {
  let {
    field,
    editMode,
    pageWidth,
    pageHeight,
    selectEditElement,
    updateField,
    handleStop,
    signatureUrl,
    onChange,
    isPatient,
    setPatientSignature,
    role,
  } = props;
  const nav = useNavStack(Stacks.Master);
  let { x_percent, y_percent, w_percent, h_percent, scale, style, id } = field;

  const inputRef = useRef(null);

  let width = 100;

  style = DocumentTemplateUtils.parseStyle(style || {}) || {};

  if (scale) width *= scale;

  let isEditable = isEditableBy(field?.editable_by, role);

  const handleClick = () => {
    if (!isPatient) {
      return;
    }
    PatientSignatureCanvasResultListener.onSave = (uri) => {
      if (uri) {
        setPatientSignature(uri);
        PatientSignatureCanvasResultListener.onSave = undefined;
      }
      nav.pop();
    };
    PatientSignatureCanvasResultListener.onCancel = () => {
      nav.pop();
    };
    nav.push(RouteUtils.publicRoutes().drawSignature);
  };

  const placeholderUrl = isPatient ? patientSignaturePlaceholderUrl : staffSignaturePlaceholderUrl;
  const url = !signatureUrl && (isPatient || editMode) ? placeholderUrl : signatureUrl;
  const showAddButton = isPatient && !editMode;
  const showSignature = editMode || signatureUrl;

  let img = (
    <>
      {showSignature && url && (
        <img
          draggable={false}
          key="signature"
          className="signature-field template-field"
          data-field-id={id}
          data-signature-role={isPatient ? 'patient' : 'staff'}
          alt="signature"
          src={url}
          style={{
            ...style,
            width: `${width}%`,
            objectFit: isPatient ? 'contain' : undefined,
            height: '100%',
            position: 'absolute',
            outline: editMode ? '1px solid #e5e7eb' : undefined,
          }}
        />
      )}
      {showAddButton && (
        <>
          <button
            className={isEditable && role === UserRoleEnum.Patient ? 'editable' : ''}
            data-content={signatureUrl ? '' : 'Add Signature'}
            onClick={handleClick}
            style={{
              width: `${width}%`,
              height: '100%',
              position: 'absolute',
              background: 'transparent',
              outline: 'none',
              margin: 'none',
              border: 'none',
              ...style,
            }}
            disabled={!isEditable || role === UserRoleEnum.Physician || role === UserRoleEnum.Admin}
          ></button>
          <input
            name={id}
            ref={inputRef}
            type="text"
            style={{ display: 'none' }}
            onChange={onChange}
          />
        </>
      )}
    </>
  );

  let x = DocumentTemplateUtils.percentToPixel(x_percent, pageWidth);
  let y = DocumentTemplateUtils.percentToPixel(y_percent, pageHeight);
  let w = DocumentTemplateUtils.percentToPixel(w_percent, pageWidth);
  let h = DocumentTemplateUtils.percentToPixel(h_percent, pageHeight);
  return DocumentTemplateUtils.getRndElement(
    id,
    img,
    { x, y, w, h },
    editMode,
    selectEditElement,
    handleStop,
    updateField,
  );
};

DocumentTemplateSignature.propTypes = {
  field: PropTypes.object,
  editMode: PropTypes.bool,
  pageWidth: PropTypes.number,
  pageHeight: PropTypes.number,
  selectEditElement: PropTypes.func,
  handleStop: PropTypes.func,
  onChange: PropTypes.func,
  updateField: PropTypes.func,
};

export default DocumentTemplateSignature;
